import { render, staticRenderFns } from "./pending-prescription-table.vue?vue&type=template&id=53e857e2&scoped=true&lang=pug&"
import script from "./pending-prescription-table.vue?vue&type=script&lang=ts&"
export * from "./pending-prescription-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e857e2",
  null
  
)

export default component.exports